var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9762 5.50621H23.3137V2.52246L2.5 5.73496V33.8937L23.3137 37.4787V33.0562H35.9762C36.3599 33.0763 36.7359 32.9433 37.0216 32.6865C37.3073 32.4296 37.4793 32.0698 37.5 31.6862V6.87496C37.479 6.49155 37.3068 6.13212 37.0211 5.87552C36.7355 5.61892 36.3597 5.48611 35.9762 5.50621ZM36.1763 31.9137H23.2713L23.25 29.5525H26.3587V26.8025H23.2262L23.2113 25.1775H26.3587V22.4275H23.1875L23.1725 20.8025H26.3587V18.0525H23.1625V16.4275H26.3587V13.6775H23.1625V12.0525H26.3587V9.30246H23.1625V6.80246H36.1763V31.9137Z",
    fill: "#20744A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1094 9.29883H33.5131V12.0488H28.1094V9.29883ZM28.1094 13.6751H33.5131V16.4251H28.1094V13.6751ZM28.1094 18.0513H33.5131V20.8013H28.1094V18.0513ZM28.1094 22.4276H33.5131V25.1776H28.1094V22.4276ZM28.1094 26.8038H33.5131V29.5538H28.1094V26.8038Z",
    fill: "#20744A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9341 13.341L10.6166 13.1873L12.3029 17.8235L14.2954 12.996L16.9779 12.8423L13.7204 19.4248L16.9779 26.0235L14.1416 25.8323L12.2266 20.8023L10.3104 25.641L7.7041 25.411L10.7316 19.5823L7.9341 13.341Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.08abb368edeed765ff6959df684df3cb.svg";
export { ForwardRef as ReactComponent };